//this file is being processed by the build-env.js to replace process.env_SOME_VARIABLE with its string or object value

export const environment = {
  environmentAlias: "dev",
  firebaseConfig: {"apiKey":"AIzaSyBbRnuxqWBMi9uH3eTLNO21iyDzIBaHhNU","appId":"1:920118146624:web:3f6397ffd85f31bd0a51a5","authDomain":"ball-score-2-b-dev.firebaseapp.com","databaseURL":"","messagingSenderId":"920118146624","projectId":"ball-score-2-b-dev","storageBucket":"ball-score-2-b-dev.appspot.com"},
  release: "ball-score@2.8.0-dev+build.2026-06-30T21-29-02",
};
